// Generated by scripts/update-seeq-icons.js from src/svg/seeq/top-tree.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcTopTree = {
  prefix: 'fak',
  iconName: 'top-tree' as IconName,
  icon: [
    834,
    1024,
    [],
    'e9ca',
    'M699.6 674.3h-82.4v-110.9h-200s0 0 0 0h-199.8l0.6 108.4-82.4 0.4-0.8-149.8c0-11 4.2-21.6 11.9-29.3s18.3-12.1 29.2-12.1h199.8l0.3-134.8 82.3 0.2-0.2 134.7h200.2s0 0 0 0c10.9 0 21.4 4.3 29.2 12s12 18.2 12 29.2v152.1zM313.9 672h-275.8c-21 0-38.1 17-38.1 38.1v275.8c0 21 17 38.1 38.1 38.1h275.8c21 0 38.1-17 38.1-38.1v-275.8c0-21-17-38.1-38.1-38.1zM282.7 954.8h-213.5v-213.5h213.5v213.5zM796.3 672h-275.8c-21 0-38.1 17-38.1 38.1v275.8c0 21 17 38.1 38.1 38.1h275.8c21 0 38.1-17 38.1-38.1v-275.8c0-21-17-38.1-38.1-38.1zM765.1 954.8h-213.5v-213.5h213.5v213.5zM593.2 313.9v-275.8c0-21-17-38.1-38.1-38.1h-275.8c-21 0-38.1 17-38.1 38.1v275.8c0 21 17 38.1 38.1 38.1h275.8c21 0 38.1-17 38.1-38.1z',
  ],
} satisfies IconDefinition;
